module.exports = __webpack_public_path__ + "static/media/passStyleBoardingPass.da0852bf.svg";